"use client";

import React, { useEffect, useRef, useState } from "react";

interface ContactMapProps {
  isEn: boolean;
}

export default function ContactMap({ isEn }: ContactMapProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [, setIsLoading] = useState(true);

  useEffect(() => {
    let map: import("leaflet").Map | undefined;
    let cancelled = false;

    async function initMap(element: HTMLElement) {
      const L = await import("leaflet");

      if (cancelled || !containerRef.current) {
        return;
      }

      map = L.map(element, { zoomControl: false }).setView([53.939535, 27.601348], 15);

      L.tileLayer("https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}", {
        attribution: "© Google Maps",
        maxZoom: 19,
      }).addTo(map);

      const customIcon = L.divIcon({
        className: "custom-marker",
        html: `<div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); width: 30px; height: 30px; border-radius: 50% 50% 50% 0; transform: rotate(-45deg); border: 3px solid white; box-shadow: 0 2px 8px rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center;"><div style="width: 8px; height: 8px; background: white; border-radius: 50%; transform: rotate(45deg);"></div></div>`,
        iconSize: [30, 30],
        iconAnchor: [15, 30],
        popupAnchor: [0, -30],
      });

      const addressText = isEn ? "Republic of Belarus, Minsk, Melezha str., 1" : "Республика Беларусь, Минск, ул. Мележа, д.1";
      const cityText = isEn ? "Minsk, Belarus" : "Минск, Беларусь";

      L.marker([53.939535, 27.601348], { icon: customIcon })
        .addTo(map)
        .bindPopup(`<div style="font-family: system-ui, sans-serif; padding: 8px; text-align: center;"><div style="font-weight: bold; color: #333; margin-bottom: 4px;">${addressText}</div><div style="color: #666; font-size: 12px;">${cityText}</div></div>`)
        .openPopup();

      setIsLoading(false);
    }

    function handleIntersect(entries: IntersectionObserverEntry[]) {
      if (entries[0].isIntersecting && containerRef.current) {
        void initMap(containerRef.current);
      }
    }

    const observer = new IntersectionObserver(handleIntersect, { rootMargin: "200px" });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      cancelled = true;
      if (observer) {
        observer.disconnect();
      }
      if (map) {
        map.remove();
      }
    };
  }, [isEn]);

  return (
    <div
      ref={containerRef}
      className="h-[600px] w-full rounded-xl overflow-hidden border border-white/10"
    />
  );
}
